import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ResourceRequestAssigneeChanged } from 'api/notifications/meta';
import { ResourceRequestTypeRenderer } from 'components/organisms/resource-management/apps/resource-request/shared/request-type-renderer';
// import { InlineLink } from '../../basics';
import { Causer } from '../causer';
import { RequestStatus } from './request-status';
import { RequestedResource } from './requested-resource';
import { AllocatedHours, ResourceRequestLink } from './utils';

export const ResourceRequestAssigneeChangedView: FC<{
  meta: ResourceRequestAssigneeChanged;
}> = ({ meta: { by, info } }) => {
  const resourceRequestType =
    info?.resourceRequestMappingModel?.resourceRequestType;

  return resourceRequestType ? (
    <FormattedMessage
      id="notifications.messages.resource_request_assignee_changed"
      values={{
        causer: <Causer user={by} />,
        requestType: (
          <ResourceRequestLink
            resourceRequestWrapper={info?.resourceRequestMappingModel}
          >
            <strong>
              <ResourceRequestTypeRenderer requestType={resourceRequestType} />
            </strong>
          </ResourceRequestLink>
        ),
        requestStatus: <RequestStatus resourceRequestStatus={info.status} />,
        requestedResource: (
          <RequestedResource
            team={{
              teamName:
                info?.resourceRequestMappingModel?.resourceRequest?.teams?.[0]
                  ?.teamName ?? '',
            }}
            user={{
              firstName:
                info?.resourceRequestMappingModel?.resourceRequest
                  ?.teamMembers?.[0]?.firstName ?? '',
              lastName:
                info?.resourceRequestMappingModel?.resourceRequest
                  ?.teamMembers?.[0]?.lastName ?? '',
            }}
          />
        ),
        allocatedHours: (
          <AllocatedHours
            minutes={
              info?.resourceRequestMappingModel.resourceRequest?.totalMins ?? 0
            }
          />
        ),
      }}
    />
  ) : null;
};
